module.exports = __webpack_public_path__ + "img/archi2Shadow@2x.65df9e1e.png";